import React, { useState } from 'react';
import { Flex } from 'antd';
import { MCustomerTable } from 'src/components/model/mCustomer/table';
import { DownloadButton, SearchBox } from 'src/components/ui';
import { FullscreenLoading } from 'src/components/function/loading';
import { useMCustomerItem } from 'src/usecases/mCustomer/reader';
import { toMCustomerId } from 'src/models/mCustomer';
import { useMCustomerUsecase } from 'src/usecases/mCustomer/usecase';
import { CsvBulkUpdate } from './csvBulkUpdate';

export const MCustomer: React.FC = () => {
  const [input, setInput] = useState<string | undefined>();
  const { data, isLoading } = useMCustomerItem({
    mCustomerId: input ? toMCustomerId(input) : undefined,
  });
  const _state = useMCustomerUsecase();

  // CSV更新中の状態
  const [csvUpdating, setCsvUpdating] = useState(false);

  return (
    <FullscreenLoading isLoading={csvUpdating}>
      <div>
        <Flex
          style={{
            background: 'white',
            borderRadius: 3,
            padding: '2%',
          }}
          vertical
          align="flex-start"
        >
          <h3 style={{ padding: '0%' }}>データダウンロード</h3>
          <div style={{ height: '10px' }}></div>
          <DownloadButton
            name="全顧客データダウンロード"
            onClick={_state.downloadAllMCustomers}
          />
        </Flex>
        <div style={{ height: '10px' }}></div>
        <SearchBox
          placeholder="顧客IDを入力してください"
          onSearch={setInput}
          children={
            data?.mCustomer ? (
              <MCustomerTable mCustomer={data.mCustomer} />
            ) : (
              <></>
            )
          }
          isLoading={isLoading}
        />
        <div style={{ height: '10px' }}></div>
        <CsvBulkUpdate 
          onUpdate={_state.bulkUpdateCustomers}
          onUpdatingChange={setCsvUpdating}
        />
      </div>
    </FullscreenLoading>
  );
};
